function isObject(v) {
  return v && typeof v === "object" && !Array.isArray(v);
}

export function deepMerge(base, override) {
  if (!isObject(base) || !isObject(override)) return override ?? base;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    if (isObject(base[key]) && isObject(override[key])) {
      out[key] = deepMerge(base[key], override[key]);
    } else if (override[key] !== undefined && override[key] !== null) {
      out[key] = override[key];
    }
  }
  return out;
}
